__turbopack_context__.v({
  "desktopCopy": "U9HwbG_desktopCopy",
  "divider": "U9HwbG_divider",
  "dot": "U9HwbG_dot",
  "dots": "U9HwbG_dots",
  "fallback": "U9HwbG_fallback",
  "heading": "U9HwbG_heading",
  "hero": "U9HwbG_hero",
  "message": "U9HwbG_message",
  "mobileCarousel": "U9HwbG_mobileCarousel",
  "mobileCopy": "U9HwbG_mobileCopy",
  "mobileDetails": "U9HwbG_mobileDetails",
  "mobileRoster": "U9HwbG_mobileRoster",
  "mobileSlide": "U9HwbG_mobileSlide",
  "mobileTeamName": "U9HwbG_mobileTeamName",
  "mobileTrack": "U9HwbG_mobileTrack",
  "panel": "U9HwbG_panel",
  "roster": "U9HwbG_roster",
  "rosterHeading": "U9HwbG_rosterHeading",
  "section": "U9HwbG_section",
  "subtitle": "U9HwbG_subtitle",
  "tab": "U9HwbG_tab",
  "tabName": "U9HwbG_tabName",
  "tabRank": "U9HwbG_tabRank",
  "tabs": "U9HwbG_tabs",
  "title": "U9HwbG_title",
  "viewMore": "U9HwbG_viewMore",
});
